import representantSitesSlice from "./representantSitesSlice";

export const administrationReducers = {
  representantSitesSlice,
};
